import { render, staticRenderFns } from "./recommend_policy_detail.vue?vue&type=template&id=998784e6&scoped=true"
import script from "./recommend_policy_detail.vue?vue&type=script&lang=js"
export * from "./recommend_policy_detail.vue?vue&type=script&lang=js"
import style0 from "./recommend_policy_detail.vue?vue&type=style&index=0&id=998784e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998784e6",
  null
  
)

export default component.exports